import { Link, useSearchParams } from "react-router-dom";
import MarketplaceShell from "../marketplace/MarketplaceShell";

export default function CheckoutFailurePage() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");

  return (
    <MarketplaceShell>
      <section className="mx-auto max-w-3xl">
        <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm">
          <div className="bg-[#7a2334] px-6 py-8 text-white">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-100">
              Checkout Not Completed
            </p>
            <h1 className="mt-3 text-3xl font-semibold">Payment was not completed</h1>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-rose-50 md:text-base">
              Your rental request was not confirmed because checkout did not finish. You can return
              to the listing and try again when you are ready.
            </p>
          </div>
          <div className="space-y-5 px-6 py-6">
            {bookingId ? (
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
                Rental reference: #{bookingId}
              </div>
            ) : null}
            <div className="flex flex-wrap gap-3">
              <Link
                to="/search"
                className="rounded-full bg-[#2f3566] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#252a53]"
              >
                Back to search
              </Link>
              <Link
                to="/account/rentals"
                className="rounded-full border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-700 hover:border-slate-400"
              >
                View my rentals
              </Link>
            </div>
          </div>
        </article>
      </section>
    </MarketplaceShell>
  );
}
